import {
  ActionContext,
  ActionTree,
  GetterTree,
  Module,
  MutationTree,
} from "vuex";
import { RootState } from "../store";

export class LoadingState {
  isLoading = false;
  message = "";
  loadingCount = 0;
  componentMessage = "";
  componentError = false;
  retryCallback: null | (() => Promise<void>) = null;
}

const state: LoadingState = new LoadingState();

const mutations: MutationTree<LoadingState> = {
  SET_LOADING_VISIBILITY(state: LoadingState, isLoading: boolean): void {
    state.isLoading = isLoading;
  },
  SET_LOADING_MESSAGE(state: LoadingState, message: string): void {
    state.message = message;
  },

  INCREMENT_COMPONENT_LOADING(state): void {
    state.loadingCount++;
  },

  DECREMENT_COMPONENT_LOADING(state): void {
    state.loadingCount = Math.max(0, state.loadingCount - 1);
  },

  SET_COMPONENT_LOADING_MESSAGE(state, message: string): void {
    state.componentMessage = message;
  },

  SET_COMPONENT_ERROR(state, value: boolean): void {
    state.componentError = value;
  },

  SET_RETRY_CALLBACK(state, callback: (() => Promise<void>) | null): void {
    state.retryCallback = callback;
  },
};

const actions: ActionTree<LoadingState, RootState> = {
  setLoadingVisibility(
    { commit }: ActionContext<LoadingState, RootState>,
    isLoading: boolean
  ): void {
    commit("SET_LOADING_VISIBILITY", isLoading);
  },

  setLoadingMessage(
    { commit }: ActionContext<LoadingState, RootState>,
    message: string
  ): void {
    commit("SET_LOADING_MESSAGE", message);
  },

  incrementComponentLoading({
                              commit,
                            }: ActionContext<LoadingState, RootState>): void {
    commit("INCREMENT_COMPONENT_LOADING");
  },

  decrementComponentLoading({
                              commit,
                            }: ActionContext<LoadingState, RootState>): void {
    commit("DECREMENT_COMPONENT_LOADING");
  },

  setComponentLoadingMessage(
    { commit }: ActionContext<LoadingState, RootState>,
    message: string
  ): void {
    commit("SET_COMPONENT_LOADING_MESSAGE", message);
  },

  setComponentError(
    { commit }: ActionContext<LoadingState, RootState>,
    value: boolean
  ): void {
    commit("SET_COMPONENT_ERROR", value);
  },

  setRetryCallback(
    { commit }: ActionContext<LoadingState, RootState>,
    callback: (() => Promise<void>) | null
  ): void {
    commit("SET_RETRY_CALLBACK", callback);
  },
};

const getters: GetterTree<LoadingState, RootState> = {
  isLoading: (state: LoadingState): boolean => state.isLoading,
  message: (state: LoadingState): string => state.message,
  isComponentLoading(state: LoadingState): boolean {
    return state.loadingCount > 0;
  },
  componentMessage(state: LoadingState): string {
    return state.componentMessage;
  },
  loadingCount(state: LoadingState): number {
    return state.loadingCount;
  },
  isComponentError(state: LoadingState): boolean {
    return state.componentError;
  },
  getRetryCallback(state: LoadingState): (() => Promise<void>) | null {
    return state.retryCallback;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as Module<LoadingState, RootState>;
